import { useState, useEffect } from 'react';
import { getSessionSurveyData } from '../../helpers/helpers';
import { usePaneViewer } from '../PaneViewer';
import Survey from './Survey';
import Loader from '../Common/Loader';

const SessionSurvey = ({ stepData, setIsTaskComplete }) => {
  const [loading, setLoading] = useState(true);
  const { onNext } = usePaneViewer(); 
  const [surveyData, setSurveyData] = useState(null);

  useEffect(() => {
    // get session start information to display on screen
    const fetchSurveyData = async () => {
      // if something happens and fetching a survey fails...just advance to the next step...
      try{
        // get the survey data
        const surveyData = await getSessionSurveyData();

        // If there is no survey data, just advance to the next step...
        if (!surveyData || !surveyData.questions || surveyData.questions.length === 0) {
          setIsTaskComplete(true); 
          onNext();
        }else if (surveyData?.questions?.some(q => q.required && q.response)) {
          // if at least one of the required questions has a response, we are going to assume the survey is completed and move them to the next step...
          setIsTaskComplete(true);
          onNext();
        }else{
          setLoading(false);
        }

        setSurveyData(surveyData);

      }catch(error){
        // If there are any issues, just advance to the next step...
        setIsTaskComplete(true);
        onNext();
        setLoading(false);
      }
    };
    fetchSurveyData();
  }, [setIsTaskComplete, onNext]);

  const handleSurveySubmit = (submitResult) => {
    if(submitResult.success){
      setIsTaskComplete(true);
      onNext();
    }
  };

  return (
    <>
      {loading && <Loader text='Generating survey...' />}
      {!loading && (
        <Survey 
          stepData={stepData} 
          setIsTaskComplete={setIsTaskComplete} 
          surveyData={surveyData} 
          onSubmit={handleSurveySubmit}
        />
      )}
    </>
  );
};

export default SessionSurvey;

